export default __webpack_public_path__ + "static/media/about-sec-img.aa223b22.png";